import { ENDPOINTS_LOANS } from 'common/endpoints/loans.endpoints';

export default class LoansSignUpService {

  constructor($http) {
    'ngInject';
    this.http = $http;
  }

  createSimulation(employeeId, simulation) {
    return this.http.post(ENDPOINTS_LOANS.post.createSimulation(employeeId), simulation);
  }
}



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansSignUp.service.js